import React, { useEffect, useState } from 'react'

export default function Footer(){
  const [year, setYear] = useState(new Date().getFullYear())

  useEffect(() => {
    setYear(new Date().getFullYear())
  }, [])

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-left">
          <div className="app-name">Travel Trip Journey</div>
          <div className="contact-info">Crafting memories, one trip at a time.</div>
        </div>
        <div className="footer-center">
          <div className="travel-quote">"The world is a book, and those who do not travel, read only one page."</div>
          <div className="copyright">© {year} Travel Trip Journey</div>
        </div>
        <div className="footer-right">
          <div className="contact-info">
            <strong>Get in Touch</strong><br />
            <a href="https://wa.me/7010690812" target="_blank" rel="noopener noreferrer">WhatsApp: 7010690812</a><br />
            <a href="mailto:info@traveltrip.com">Email: info@traveltrip.com</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
